module.exports = __webpack_public_path__ + "img/bg-competition2.7113a90b.png";